import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Panel from "../components/Panel";
import KpiCard from "../components/KpiCard";
import { fmtINR } from "../lib/format";

export default function HR() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/hr/employees").then((r) => setData(r.data)); }, []);
    if (!data) return <div className="font-mono-fin text-sm text-[var(--text-secondary)]">// LOADING HR...</div>;

    return (
        <div className="space-y-4">
            <div>
                <div className="font-mono-fin text-[10px] uppercase tracking-[0.25em] text-[var(--brand-amber)] mb-1">// HR & LABOUR</div>
                <h1 className="font-display font-black text-3xl">People & Productivity</h1>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <KpiCard testId="hr-headcount" label="Total Employees" value={data.summary.count} format="custom" sub={`+${data.labour.total_present_today} labour today`} accent />
                <KpiCard testId="hr-ctc" label="Annual CTC" value={data.summary.total_ctc} sub="Fixed cost base" />
                <KpiCard testId="hr-kpi" label="Avg KPI Score" value={`${data.summary.avg_kpi.toFixed(1)}`} format="custom" sub="Target 85+" />
                <KpiCard testId="hr-attrition" label="Attrition YTD" value={`${data.labour.attrition_pct_ytd}%`} format="custom" sub="High" />
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-2 gap-3">
                <Panel testId="hr-labour" title="Labour on Site" subtitle={`${data.labour.total_present_today} present · ${data.labour.contractor_labour} contract + ${data.labour.permanent_labour} permanent`}>
                    <table className="w-full font-mono-fin text-xs">
                        <thead className="border-b border-panel">
                            <tr className="text-[10px] uppercase tracking-wider text-[var(--text-secondary)]">
                                <th className="text-left py-2">Project</th>
                                <th className="text-right">Labour</th>
                                <th className="text-right">Daily Cost</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.labour.by_project.map((l) => (
                                <tr key={l.project_id} className="border-b border-[var(--border)]/50">
                                    <td className="py-2 text-[var(--text-primary)]">{l.project_id}</td>
                                    <td className="text-right text-[var(--text-primary)]">{l.count}</td>
                                    <td className="text-right text-amber">{fmtINR(l.cost_per_day)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="mt-3 pt-3 border-t border-panel text-[10px] font-mono-fin uppercase tracking-wider text-[var(--text-secondary)]">
                        Productivity Index: <span className="text-pos">{data.labour.productivity_index.toFixed(2)}</span>
                    </div>
                </Panel>

                <Panel testId="hr-dept" title="Department Cost & Performance">
                    <table className="w-full font-mono-fin text-xs">
                        <thead className="border-b border-panel">
                            <tr className="text-[10px] uppercase tracking-wider text-[var(--text-secondary)]">
                                <th className="text-left py-2">Department</th>
                                <th className="text-right">Headcount</th>
                                <th className="text-right">CTC (Cr)</th>
                                <th className="text-right">Avg KPI</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.by_dept.map((d) => (
                                <tr key={d.dept} className="border-b border-[var(--border)]/50">
                                    <td className="py-2 text-[var(--text-primary)]">{d.dept}</td>
                                    <td className="text-right text-[var(--text-primary)]">{d.count}</td>
                                    <td className="text-right text-amber">{fmtINR(d.cost)}</td>
                                    <td className={`text-right ${d.avg_kpi >= 85 ? "text-pos" : d.avg_kpi >= 75 ? "text-amber" : "text-neg"}`}>{d.avg_kpi}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Panel>
            </div>

            <Panel testId="hr-employees" title="Employee Directory">
                <div className="overflow-x-auto">
                    <table className="w-full font-mono-fin text-xs">
                        <thead className="border-b border-panel">
                            <tr className="text-[10px] uppercase tracking-wider text-[var(--text-secondary)]">
                                <th className="text-left py-2">Emp ID</th>
                                <th className="text-left">Name</th>
                                <th className="text-left">Role</th>
                                <th className="text-left">Dept</th>
                                <th className="text-right">CTC</th>
                                <th className="text-right">Attendance</th>
                                <th className="text-right">KPI</th>
                                <th className="text-left">Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.employees.map((e) => (
                                <tr key={e.id} className="border-b border-[var(--border)]/50 hover:bg-[var(--bg-panel-hover)]">
                                    <td className="py-2 text-[var(--text-secondary)]">{e.id}</td>
                                    <td className="text-[var(--text-primary)]">{e.name}</td>
                                    <td className="text-[var(--text-secondary)]">{e.role}</td>
                                    <td className="text-[var(--text-secondary)] text-[10px] uppercase tracking-wider">{e.dept}</td>
                                    <td className="text-right text-[var(--text-primary)]">{fmtINR(e.ctc)}</td>
                                    <td className="text-right text-[var(--text-primary)]">{e.attendance_pct}%</td>
                                    <td className={`text-right ${e.kpi_score >= 85 ? "text-pos" : e.kpi_score >= 75 ? "text-amber" : "text-neg"}`}>{e.kpi_score}</td>
                                    <td><span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 border border-panel">{e.type}</span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Panel>
        </div>
    );
}
